import { createContext, useContext } from "react";

export interface DescriptionListContextValue {
  translationKey: string;
  data: Record<string, unknown>;
}

const DescriptionListContext = createContext<DescriptionListContextValue>({
  translationKey: "",
  data: {},
});

export default DescriptionListContext;

export const useDescriptionListContext = () => {
  const context = useContext(DescriptionListContext);
  if (context === undefined) {
    throw new Error(
      "DescriptionListContext must be used within a DescriptionListContextProvider",
    );
  }
  return context;
};
